import { Backdrop, Box, Button, Grow, Modal, Radio, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import HolzfinderCommaNumberInput from "components/inputs/HolzfinderCommaNumberInput";
import { bulkEdit } from "features/lotlist/bulkEditSlice";
import { selectSorting } from "features/lotlist/filterAndSortSlice";
import { getLotList } from "features/lotlist/lotListSlice";
import { selectLotListTab, selectPageLotList, selectRowsPerPageLotList } from "features/table/tableSlice";
import { selectUserRole } from "features/user/userSlice";
import { formatNumberInput, validateNumberInput } from "functions/lotPrice";
import { useContext, useEffect, useState } from "react";
import { lotListTabNames, ModalContext } from "../LosListe";

interface Props {
    checkedBoxes: string[];
    searchQuery?: string;
}

export default function BulkPriceEdit(props: Props) {
    const validPriceRegex = /^\d+((\.|,)\d+)?$/;
    const dispatch = useAppDispatch();
    const userRole = useAppSelector(selectUserRole);
    const rowsPerPage = useAppSelector(selectRowsPerPageLotList);
    const page = useAppSelector(selectPageLotList);
    const tab = useAppSelector(selectLotListTab);
    const sort = useAppSelector(selectSorting)
    const { checkedBoxes, searchQuery } = props;
    const { modalOpened, handleClose } = useContext(ModalContext);
    const [netPriceActive, setNetPriceActive] = useState(true)
    const [netPrice, setNetPrice] = useState<string>("0,00")
    const [grossPrice, setGrossPrice] = useState<string>("0,00")
    const [nonValidNumber, setNonValidNumber] = useState(false)
    const [alreadyConfirmed, setAlreadyConfirmed] = useState(false)
    const [isPriceZero, setIsPriceZero] = useState(false);
    useEffect(() => {
        setAlreadyConfirmed(false);
    }, [modalOpened]);

    useEffect(() => {
        if (netPriceActive) {
            setIsPriceZero(parseFloat(netPrice.replace(",", ".")) === 0);
        } else {
            setIsPriceZero(parseFloat(grossPrice.replace(",", ".")) === 0);
        }
    }, [netPriceActive, netPrice, grossPrice])

    const handleNetInput = (value: string) => {
        const isValidPrice = validPriceRegex.test(value);
        if (isValidPrice) {
            setNetPrice(Number(value.replace(",", ".")).toFixed(2).replace(".", ","))
            setNonValidNumber(false)
        } else {
            setNetPrice("0,00");
            setNonValidNumber(true)
        }
    }
    const handleGrossInput = (value: string) => {
        const isValidPrice = validPriceRegex.test(value);
        if (isValidPrice) {
            setGrossPrice(Number(value.replace(",", ".")).toFixed(2).replace(".", ","))
            setNonValidNumber(false)
        } else {
            setGrossPrice("0,00");
            setNonValidNumber(true);
        }
    }
    const checkIfvalid = (value: string) => {
        return validPriceRegex.test(value)
    }

    const handleCheckboxChange = () => {
        setNetPriceActive(!netPriceActive)
    }
    const handleConfirmed = () => {
        if (netPriceActive) {
            if (checkIfvalid(netPrice)) {
                sendNewPrice("net", netPrice)
                setAlreadyConfirmed(true)
            } else {
                setNonValidNumber(true)
            }
        } else {
            if (checkIfvalid(grossPrice)) {
                setAlreadyConfirmed(true)
                sendNewPrice("gross", grossPrice)
            } else {
                setNonValidNumber(true)
            }

        }
    }
    const sendNewPrice = (type: string, price: string) => {
        dispatch(
            bulkEdit({
                ids: checkedBoxes,
                type: type,
                price: parseFloat(price.replace(",", ".")),
                endpoint: userRole,
            })
        ).then(() => {
            dispatch(
                getLotList({
                    items_per_page: rowsPerPage,
                    page: page + 1,
                    search: searchQuery,
                    status: lotListTabNames[tab],
                    sort: sort,
                })
            );
            setAlreadyConfirmed(false);
            handleClose(true);
        }).catch((e) => {
            setAlreadyConfirmed(false);
            console.error(e)
        });
    }

    return (
        <Backdrop sx={{ zIndex: 1200 }} open={modalOpened}>
            <Modal hideBackdrop open={modalOpened} onClose={() => handleClose()} aria-labelledby="modal-title">
                <Box>
                    <Grow in={true} style={{ transform: "translate(-50%, -50%)" }}>
                        <Box sx={{
                            width: "30%",
                            minWidth: "300px",
                            maxWidth: "90%",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            backgroundColor: "white",
                            transform: "translate(-50%, -50%)",
                            borderRadius: "16px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            padding: 4,
                            textAlign: "center",
                        }}>
                            <Typography fontSize={20} fontWeight={"bold"}>
                                {`Geben Sie den gewünschten Preis für die ausgewählten Lose (${checkedBoxes.length}) an. `}
                            </Typography>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignContent: "center" }}>
                                <Box sx={{ flexDirection: "row" }}>
                                    <Radio
                                        checked={netPriceActive ? true : false}
                                        onChange={handleCheckboxChange}
                                        name="radio-buttons"
                                        sx={{ color: "#00000061" }}
                                    />
                                    <HolzfinderCommaNumberInput
                                        unit="Netto Preis €/Fm"
                                        value={netPrice}
                                        disabled={netPriceActive ? false : true}
                                        onChange={handleNetInput}
                                        validateInput={(s) => validateNumberInput(s, 3)}
                                        formatInput={formatNumberInput}
                                        style={{ width: '75%' }}
                                    />
                                </Box>
                                <Box sx={{ flexDirection: "row" }}>
                                    <Radio
                                        checked={netPriceActive ? false : true}
                                        onChange={handleCheckboxChange}
                                        name="radio-buttons"
                                        sx={{ color: "#00000061" }}
                                    />
                                    <HolzfinderCommaNumberInput
                                        unit="Brutto Preis €/Fm"
                                        value={grossPrice}
                                        disabled={netPriceActive ? true : false}
                                        onChange={handleGrossInput}
                                        validateInput={(s) => validateNumberInput(s, 3)}
                                        formatInput={formatNumberInput}
                                        style={{ width: '75%' }}

                                    />
                                </Box>
                            </Box>
                            {nonValidNumber ? (
                                <Typography fontSize={17.5} fontWeight={"bold"} sx={{ color: "rgb(211, 47, 47)", alignSelf: "normal" }}>
                                    Bitte geben Sie einen Wert größer als 0 ein.
                                </Typography>
                            ) : null}
                            <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 1, mt: 2 }}>
                                <Button
                                    onClick={() => {
                                        handleClose()
                                    }}
                                    sx={{
                                        flexGrow: 1,
                                        borderRadius: "26px",
                                        color: "#072D26",
                                        fontWeight: "bold",
                                        border: "2px solid #C0D904",
                                        height: "51px",
                                        paddingLeft: "50px",
                                        paddingRight: "50px",
                                        "&:hover": { background: "#c0d904" }
                                    }}>
                                    Abbrechen
                                </Button>
                                <Button
                                    onClick={() => {
                                        handleConfirmed()
                                    }}
                                    disabled={alreadyConfirmed || isPriceZero}
                                    sx={{
                                        flexGrow: 1,
                                        borderRadius: "26px",
                                        color: "#072D26",
                                        fontWeight: "bold",
                                        border: "2px solid #C0D904",
                                        height: "51px",
                                        paddingLeft: "50px",
                                        paddingRight: "50px",
                                        "&:hover": { background: "#c0d904" }
                                    }}
                                >
                                    Bestätigen
                                </Button>
                            </Box>
                        </Box>
                    </Grow>
                </Box>
            </Modal>
        </Backdrop>
    )
}